// Firebase Client Configuration
// Replace with your Firebase project credentials
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'your-api-key',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'your-project.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'your-project-id',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'your-project.appspot.com',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || 'your-sender-id',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || 'your-app-id',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'your-measurement-id'
};

// Vertex AI Configuration (models only - API key is server-side)
export const vertexAIConfig = {
  projectId: import.meta.env.VITE_GOOGLE_CLOUD_PROJECT || 'your-gcp-project',
  location: 'europe-west4',
  // Gemini models (used by backend)
  textModel: 'gemini-3.8-flash',
  visionModel: 'gemini-3.8-flash',
  // Gemini Live for real-time audio/video streaming
  liveModel: 'gemini-live-2.5-flash-native-audio',
};

// App Configuration
export const appConfig = {
  defaultLanguage: 'de',
  supportedLanguages: ['de', 'en', 'pl', 'tr', 'ro', 'uk'],
  defaultCurrency: 'EUR',
  defaultTaxRate: 19, // German VAT
  maxImageSize: 10 * 1024 * 1024, // 10MB
  maxVideoLength: 60, // seconds
};
